import React from "react";

const C_box = ({ icon, info1, info2 }) => {
  return (
    <div class="h-full box-content lg:w-96 items-center flex flex-col py-2 max-w-full px-5 bg-primary text-base-300 rounded-lg">
      <figure className="text-4xl lg:text-6xl pt-5 text-info">{icon}</figure>
      <div class="p-4">
        <h2 class="card-title pr-2 lg:text-xl text-sm">{info1}</h2>
        <h2 class="card-title pr-2 lg:text-xl text-sm">{info2}</h2>
      </div>
    </div>
  );
};

export default C_box;
